import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DEMO_MODE_STORAGE_KEY } from './demo-mode.constants';

@Injectable({
  providedIn: 'root',
})
export class DemoModeService {
  private readonly demoModeSubject = new BehaviorSubject<boolean>(this.readFromStorage());

  readonly demoMode$: Observable<boolean> = this.demoModeSubject.asObservable();

  isDemoMode(): boolean {
    return this.demoModeSubject.value;
  }

  setDemoMode(enabled: boolean): void {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem(DEMO_MODE_STORAGE_KEY, enabled ? 'true' : 'false');
    }
    this.demoModeSubject.next(enabled);
  }

  private readFromStorage(): boolean {
    if (typeof window === 'undefined' || !window.localStorage) {
      return false;
    }
    return window.localStorage.getItem(DEMO_MODE_STORAGE_KEY) === 'true';
  }
}
